<aside title="login status">
  <div class="bg-blue">
    <div class="m-w-1200 mx-auto flex space-between py-4 text-white">
      <div class="flex gap-16">
        @if (user?.username) {
          <span>{{ user?.username }}</span>
        }
        @if (user?.role === 'gp') {
          <span>Practice</span>
        }
        @if (user?.role === 'hv') {
          <span>Health visiting team</span>
        }
        @if (user?.role === 'sn') {
          <span>School age Immunisation team</span>
        }
        @if (user?.role === 'pd') {
          <span>Paediatric team</span>
        }
        @if (user?.organisation && user?.admin !== 'true') {
          <span>{{ user?.organisation }}</span>
        }
        @if (user?.organisation && user?.admin === 'true') {
          <span>NHS SCW</span>
        }
        @if (user?.admin === 'true' && user?.impersonated_orgname) {
          <span>( {{ user?.impersonated_orgname }} )</span>
        }
      </div>
      <div class="flex gap-16">
        @if (user?.role === 'hv' || user?.role === 'sn' || user?.admin === 'true') {
          <a routerLink="/role">Change role</a>
        }
        <button class="nhsuk-link withPointer" (click)="signOut()">Sign out</button>
      </div>
    </div>
  </div>
</aside>
